module.exports = __webpack_public_path__ + "static/img/mrimg.181ca83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mrimg.png
// module id = 3wQc
// module chunks = 1